import { RegisterSystemUserRequest } from './registration.types';

import { API_HOST, HttpPostOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/registration`;

export const getRegisterSystemUserRequest = (
  data: RegisterSystemUserRequest
): [string, HttpPostOptions<RegisterSystemUserRequest>] => [getEndpoint(), getHttpPostOptions(data)];
